import React, { forwardRef, useCallback, useImperativeHandle, useMemo } from 'react';

import { useSelector } from 'react-redux';
import clsx from 'clsx';
import { withStyles, Theme, MenuItem, ListItemText } from '@material-ui/core';
import { useWkblVideo } from 'hooks';
import { PageReturnCountOptions } from 'commons/constants/KeyFlowConstants';
import { PageReturnOptionsProps, PageReturnOptionProps } from 'components/SelectOptions/type';
import { RootState, WkblVideoState } from 'redux/reducers/type';

const StyledMenuItem = withStyles((theme: Theme) => ({
  root: {
    '&.Mui-selected': {
      backgroundColor: '#D94F98',
      '& > *': {
        color: '#ffffff',
      },
    },
    '&:focus': {
      backgroundColor: '#D94F98',
      '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
        color: theme.palette.common.white,
      },
    },
  },
}))(MenuItem);

function Option({ name, value, isActive, onClick }: PageReturnOptionProps) {
  const onClickItem = useCallback(() => {
    onClick(value);
  }, [onClick, value]);

  return (
    <StyledMenuItem onClick={onClickItem} selected={isActive}>
      <ListItemText>{name}</ListItemText>
    </StyledMenuItem>
  );
}

function PageReturnOptions({ returnCount, onClose, onChangeReturnCount }: PageReturnOptionsProps) {
  const onClick = useCallback(
    (value: number) => {
      onChangeReturnCount(value);
      onClose();
    },
    [onChangeReturnCount],
  );

  return (
    <>
      {PageReturnCountOptions.map(pageOption => (
        <Option isActive={returnCount === pageOption.value} onClick={onClick} {...pageOption} />
      ))}
    </>
  );
}

export default PageReturnOptions;
